import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";

import Button from "@mui/material/Button";
import LockOpenIcon from "@mui/icons-material/LockOpen";

import {featureInterface} from "../../../../../interfaces/featureInterface";
import {setLookOverlayOpened} from "../../../../../actions/lookFunctions";
import {LOOK_OVERLAYS} from "../../../core/constants";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../../../analytics";

const LookFeatureUnlockButton = (props) => {

  const {setLookOverlayOpened,} = props;

  const unlockButtonClick = () => {
    Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookFeatureUnlock);
    setLookOverlayOpened(LOOK_OVERLAYS.leadCapture);
  };

  return (
    <div className="lk-feature__unlock">
      <Button className={"look-button look-button--secondary look-button--white look-button--max"}
              startIcon={<LockOpenIcon />}
              onClick={unlockButtonClick}>
        <FormattedMessage id="look.feature.unlockButton"/>
      </Button>
    </div>
  )
};

LookFeatureUnlockButton.propTypes = {
  lookFeature: PropTypes.shape(featureInterface),
}

const mapStateToProps = (store) => {
  const {lookActiveFeature} = store.lookState;

  return {
    lookActiveFeature
  };
};

const mapDispatchToProps = {
  setLookOverlayOpened,
};

export default connect(mapStateToProps, mapDispatchToProps)(LookFeatureUnlockButton)
